module.exports = __webpack_public_path__ + "static/media/logo-purple.58046042.svg";